import { useEffect, useState } from 'react';
import Header from './Header';
import GlobalSignalsBar from './GlobalSignalsBar';
import Sidebar from './Sidebar';

const DESKTOP_BREAKPOINT = 1024;
const SIDEBAR_WIDTH = 256;

export default function Layout({
  children,
  searchPlaceholder = 'Search parameters...',
}) {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (typeof window === 'undefined') return true;
    return window.innerWidth >= DESKTOP_BREAKPOINT;
  });
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < DESKTOP_BREAKPOINT;
  });

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < DESKTOP_BREAKPOINT;
      setIsMobile(mobile);
      setSidebarOpen((current) => (mobile ? current : true));
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMobile && sidebarOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobile, sidebarOpen]);

  const [light, setLight] = useState(() => {
    if (typeof document === 'undefined') return false;
    return document.documentElement.classList.contains('light');
  });
  const toggleTheme = () => {
    setLight((prev) => {
      const next = !prev;
      document.documentElement.classList.toggle('light', next);
      try {
        localStorage.setItem('shimbirr-admin-theme', next ? 'light' : 'dark');
      } catch (e) {
        /* storage may be unavailable */
      }
      return next;
    });
  };

  return (
    <div className="min-h-screen bg-[#131313] text-[#e5e2e1]">
      {isMobile && sidebarOpen ? (
        <button
          type="button"
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 z-40 bg-black/70 backdrop-blur-sm lg:hidden"
          aria-label="Close navigation overlay"
        />
      ) : null}

      <Sidebar
        isOpen={sidebarOpen}
        isMobile={isMobile}
        onClose={() => setSidebarOpen(false)}
      />

      <Header
        onMenu={() => setSidebarOpen((current) => !current)}
        searchPlaceholder={searchPlaceholder}
      />

      <main
        className="min-h-screen bg-[#131313] pt-16"
        style={{ marginLeft: isMobile ? 0 : SIDEBAR_WIDTH }}
      >
        <div className="mx-auto w-full max-w-[1440px] px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
          <GlobalSignalsBar />
          {children}
        </div>
      </main>

      <button
        type="button"
        onClick={toggleTheme}
        aria-label={light ? 'Switch to night theme' : 'Switch to day theme'}
        title={light ? 'Night theme' : 'Day theme'}
        className="fixed bottom-5 right-5 z-50 flex h-12 w-12 items-center justify-center rounded-full border border-[#4e4632] bg-[#1c1b1b] text-[#ffcc00] shadow-lg transition hover:brightness-110"
      >
        <span className="material-symbols-outlined" style={{ fontSize: 22 }}>
          {light ? 'dark_mode' : 'light_mode'}
        </span>
      </button>
    </div>
  );
}
